<kanzi-ui-main-card
  title="{{ 'analytics.flight_list' | translate }}"
  description="{{ 'analytics.flight_list_description' | translate }}"
>
  <kanzi-dynamic-table
    [colSource]="cols"
    [configs]="configsTable"
    [dataSource]="reportList"
  >
  </kanzi-dynamic-table>
</kanzi-ui-main-card>
